export default __webpack_public_path__ + "static/media/logoWhite.64776ec5.svg";